import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Icon from "../components/Icon"
import { useSignal, useComputed, effect } from '@preact/signals-react'

function VersionTooltip({ version, availableVersions, context }) {
    const versionOutOfDateSignal = useSignal(false);
    const currentVersion = useComputed(() => extractVersion(version));
    const gaVersion = useComputed(() => {
        if (availableVersions?.length) {
            const filteredVersions = availableVersions.filter((item) => item.generalAvailability === true)
            return filteredVersions ? extractVersion(filteredVersions[0].version) : null
        }
        return null
    })

    function extractVersion(versionString) {
        if (versionString) {
            if (/^\d+\.\d+\.\d+\.\d+$/.test(versionString)) {
                return versionString
            }
            const match = versionString.match(/(\d+\.\d+\.\d+\.\d+)/);
            return match ? match[0] : null
        } else {
            return null
        }
    }

    // Convert x.x.x.x to an array of numbers for easier comparisons
    function parseVersion(str) {
        return str.split('.').map((part) => parseInt(part, 10));
    }

    // Compare two x.x.x.x versions
    function compareVersions(a, b) {
        const [a1, a2, a3, a4] = parseVersion(a);
        const [b1, b2, b3, b4] = parseVersion(b);
        if (a1 !== b1) return a1 < b1;
        if (a2 !== b2) return a2 < b2;
        if (a3 !== b3) return a3 < b3;
        return a4 < b4

    }

    effect(() => {
        if (currentVersion.value && gaVersion.value) {
            const isOutOfDate = compareVersions(currentVersion.value, gaVersion.value)
            versionOutOfDateSignal.value = isOutOfDate
        } else {
            versionOutOfDateSignal.value = false
        }
    });

    const renderTooltip = (props) => (
        <Tooltip {...props}>
            <div>
                The {context} version you are currently using is out of date. Please schedule a
                task for the {context} to &ldquo;Upgrade {context} to Latest Version&rdquo;.
            </div>
        </Tooltip>
    )

    return (
        <Col sm="10">
            {(versionOutOfDateSignal.value == true) && (
                <Form.Group className="d-flex align-items-center">
                    <Form.Control
                        plaintext
                        readOnly
                        value={version}
                        className="sm-1"
                        style={{ width: 'auto' }}
                    />
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 100, hide: 250 }}
                        overlay={renderTooltip}
                    >
                        <a>
                            <Icon icon="warning-triangle" width="16" height="16" />
                        </a>
                    </OverlayTrigger>
                </Form.Group>

            )}

            {(versionOutOfDateSignal.value == false) && (
                <Form.Control plaintext readOnly value={version} />
            )}

        </Col>
    )
}

export default VersionTooltip;
